import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  BarChart3,
  Users,
  AlertTriangle,
  Cpu,
  Shield,
  Ticket,
  MessageSquare,
} from 'lucide-react';

const dashboards = [
  {
    key: 'executive',
    path: '/intelligence/executive',
    icon: BarChart3,
    color: 'bg-blue-500',
  },
  {
    key: 'customers',
    path: '/intelligence/customers',
    icon: Users,
    color: 'bg-green-500',
  },
  {
    key: 'alerts',
    path: '/intelligence/alerts',
    icon: AlertTriangle,
    color: 'bg-amber-500',
  },
  {
    key: 'devices',
    path: '/intelligence/devices',
    icon: Cpu,
    color: 'bg-purple-500',
  },
  {
    key: 'compliance',
    path: '/intelligence/compliance',
    icon: Shield,
    color: 'bg-teal-500',
  },
  {
    key: 'operations',
    path: '/intelligence/operations',
    icon: Ticket,
    color: 'bg-orange-500',
  },
  {
    key: 'communications',
    path: '/intelligence/communications',
    icon: MessageSquare,
    color: 'bg-pink-500',
  },
];

export default function IntelligenceOverviewPage() {
  const { t } = useTranslation('intelligence');

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-semibold text-foreground">{t('title')}</h1>
        <p className="text-muted-foreground mt-1">
          Select a dashboard to view detailed analytics
        </p>
      </div>

      {/* Dashboard Grid */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {dashboards.map((dashboard) => {
          const Icon = dashboard.icon;
          return (
            <Link key={dashboard.key} to={dashboard.path}>
              <Card className="h-full cursor-pointer transition-all hover:shadow-md hover:border-primary/30">
                <CardHeader className="pb-2">
                  <div className="flex items-center gap-3">
                    <div className={`p-2 rounded-lg ${dashboard.color}`}>
                      <Icon className="h-5 w-5 text-white" />
                    </div>
                    <CardTitle className="text-base">
                      {t(`${dashboard.key}.title`)}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription>
                    {t(`${dashboard.key}.subtitle`)}
                  </CardDescription>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>

      {/* Coming Soon Notice */}
      <Card className="border-dashed">
        <CardContent className="py-6 text-center">
          <p className="text-muted-foreground">
            Intelligence dashboards are being migrated from the legacy application.
            <br />
            Full functionality will be available soon.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
